$ = jQuery;

$(document).ready(function() {
    if (screen.width < 375) {
        var mvp = document.getElementById('vp');
        mvp.setAttribute('content','user-scalable=no,width=375');
    }
})
